export function domain() {
  return (
    {
      hml: 'https://dashboard.homolog.stone.credit',
      sdb: 'https://sandbox.conta.stone.com.br',
      prod: 'https://conta.stone.com.br'
    }[process.env.APP_ENV as string] || 'https://conta.stone.com.br'
  )
}
